import { env } from 'core/utils/env';
import type { ActionsTypes, ResolvingStatus, UrlList } from 'core/types';

export enum ActionTypes {
  APP_NAME_SET = 'APP_NAME_SET',
  HIDE_ALERT = 'HIDE_ALERT',
  SHOW_ALERT = 'SHOW_ALERT',
  ASSIGNMENT_WINDOW_SHOW = 'ASSIGNMENT_WINDOW_SHOW',
  ASSIGNMENT_WINDOW_HIDE = 'ASSIGNMENT_WINDOW_HIDE',
  LOADING_SHOW = 'LOADING_SHOW',
  LOADING_HIDE = 'LOADING_HIDE',
  LOADING_SET_MESSAGE = 'LOADING_SET_MESSAGE',
  USER_INFO_REQUEST = 'USER_INFO_REQUEST',
  USER_INFO_SUCCESS = 'USER_INFO_SUCCESS',
  USER_INFO_FAILURE = 'USER_INFO_FAILURE',
  USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST',
  USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS',
  USER_LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE',
  USER_SHOW_ALERT_WELCOME = 'USER_SHOW_ALERT_WELCOME',
  POUCH_DB_REMOVE = 'POUCH_DB_REMOVE',
  POUCH_DB_REMOVE_SUCCESS = 'POUCH_DB_REMOVE_SUCCESS',
  POUCH_DB_REMOVE_FAILURE = 'POUCH_DB_REMOVE_FAILURE',
  POUCH_DB_IMPORT = 'POUCH_DB_IMPORT',
  POUCH_DB_IMPORT_SUCCESS = 'POUCH_DB_IMPORT_SUCCESS',
  POUCH_DB_IMPORT_FAILURE = 'POUCH_DB_IMPORT_FAILURE',
  POUCH_DB_GET_WORKSPACES = 'POUCH_DB_GET_WORKSPACES',
  POUCH_DB_GET_WORKSPACES_SUCCESS = 'POUCH_DB_GET_WORKSPACES_SUCCESS',
  POUCH_DB_GET_WORKSPACES_FAILURE = 'POUCH_DB_GET_WORKSPACES_FAILURE',
  POUCH_DB_SET_ITEM = 'POUCH_DB_SET_ITEM',
  POUCH_DB_GET_LIST = 'POUCH_DB_GET_LIST',
  POUCH_DB_GET_LIST_SUCCESS = 'POUCH_DB_GET_LIST_SUCCESS',
  POUCH_DB_GET_LIST_FAILURE = 'POUCH_DB_GET_LIST_FAILURE',
  POUCH_DB_ASSIGNMENT_GET_LIST = 'POUCH_DB_ASSIGNMENT_GET_LIST',
  POUCH_DB_ASSIGNMENT_GET_LIST_SUCCESS = 'POUCH_DB_ASSIGNMENT_GET_LIST_SUCCESS',
  POUCH_DB_ASSIGNMENT_GET_LIST_FAILURE = 'POUCH_DB_ASSIGNMENT_GET_LIST_FAILURE',
  POUCH_DB_SEARCH = 'POUCH_DB_SEARCH',
  POUCH_DB_SEARCH_ENABLED = 'POUCH_DB_SEARCH_ENABLED',
  POUCH_DB_SEARCH_SUCCESS = 'POUCH_DB_SEARCH_SUCCESS',
  POUCH_DB_SEARCH_FAILURE = 'POUCH_DB_SEARCH_FAILURE',
  POUCH_DB_SAVE_ORDER = 'POUCH_DB_SAVE_ORDER',
  POUCH_DB_SAVE_ORDER_SUCCESS = 'POUCH_DB_SAVE_ORDER_SUCCESS',
  POUCH_DB_SAVE_ORDER_FAILURE = 'POUCH_DB_SAVE_ORDER_FAILURE',
  ORGANIZATION_GET_USERS = 'ORGANIZATION_GET_USERS',
  ORGANIZATION_GET_USERS_SUCCESS = 'ORGANIZATION_GET_USERS_SUCCESS',
  ORGANIZATION_GET_USERS_FAILURE = 'ORGANIZATION_GET_USERS_FAILURE',
  POUCH_DB_CREATE_WORKSPACE = 'POUCH_DB_CREATE_WORKSPACE',
  EDITOR_GET_DOCUMENT_ID = 'EDITOR_GET_DOCUMENT_ID',
  EDITOR_GET_DOCUMENT_SUCCESS = 'EDITOR_GET_DOCUMENT_SUCCESS',
  EDITOR_GET_DOCUMENT_FAILURE = 'EDITOR_GET_DOCUMENT_FAILURE',
  EDITOR_UPDATING_DOCUMENT = 'EDITOR_UPDATING_DOCUMENT',
  EDITOR_PUT_DOCUMENT_REV = 'EDITOR_PUT_DOCUMENT_REV',
  EDITOR_PUT_DOCUMENT = 'EDITOR_PUT_DOCUMENT',
  EDITOR_PUT_DOCUMENT_SUCCESS = 'EDITOR_PUT_DOCUMENT_SUCCESS',
  EDITOR_PUT_DOCUMENT_FAILURE = '  EDITOR_PUT_DOCUMENT_FAILURE',
  EDITOR_PLUGINS_SET_CODES = 'EDITOR_PLUGINS_SET_CODES',
  EDITOR_PLUGINS_SET_ATTRIBUTES = 'EDITOR_PLUGINS_SET_ATTRIBUTES',
  EDITOR_CREATE_DOCUMENT = 'EDITOR_CREATE_DOCUMENT',
  EDITOR_CREATE_DOCUMENT_SUCCESS = 'EDITOR_CREATE_DOCUMENT_SUCCESS',
  EDITOR_CREATE_DOCUMENT_FAILURE = 'EDITOR_CREATE_DOCUMENT_FAILURE',
  WORKSPACE_INIT = 'WORKSPACE_INIT',
  WORKSPACE_INIT_SUCCESS = 'WORKSPACE_INIT_SUCCESS',
  WORKSPACE_INIT_FAILURE = 'WORKSPACE_INIT_FAILURE',
  WORKSPACE_LOAD_BY_ITEM_ID = 'WORKSPACE_LOAD_BY_ITEM_ID',
  WORKSPACE_LOAD_BY_ITEM_ID_SUCCESS = 'WORKSPACE_LOAD_BY_ITEM_ID_SUCCESS',
  WORKSPACE_LOAD_BY_ITEM_ID_FAILURE = 'WORKSPACE_LOAD_BY_ITEM_ID_FAILURE',
  WORKSPACE_SET_CHILDREN = 'WORKSPACE_SET_CHILDREN',
  WORKSPACE_SET_PARENTS = 'WORKSPACE_SET_PARENTS',
  WORKSPACE_SET_ID = 'WORKSPACE_SET_ID',
  ASSIGNMENT_SET = 'ASSIGNMENT_SET',
  ASSIGNMENT_SET_RESET_STATUS = 'ASSIGNMENT_SET_RESET_STATUS',
  ASSIGNMENT_SET_SUCCESS = 'ASSIGNMENT_SET_SUCCESS',
  ASSIGNMENT_SET_FAILURE = 'ASSIGNMENT_SET_FAILURE',
  ASSIGNMENT_GET = 'ASSIGNMENT_GET',
  ASSIGNMENT_GET_SUCCESS = 'ASSIGNMENT_GET_SUCCESS',
  ASSIGNMENT_GET_FAILURE = 'ASSIGNMENT_GET_FAILURE',
  SEARCH_PANEL_SHOW = 'SEARCH_PANEL_SHOW',
  SEARCH_PANEL_HIDE = 'SEARCH_PANEL_HIDE',
  SEARCH_PANEL_SHOW_RESULTS = 'SEARCH_PANEL_SHOW_RESULTS',
  CONFLICT_SET = 'CONFLICT_SET',
  TERMINATE_APP = 'TERMINATE_APP',
}

export const RESOLVING_STATUS: ResolvingStatus = {
  RESOLVED: 'Resolved',
  UNRESOLVED: 'Unresolved',
};

export const RESOLVING_STATUS_ANY: ResolvingStatus = {
  ANY: 'Any',
  ...RESOLVING_STATUS,
};

export const ACTION_TYPE: ActionsTypes = {
  SETTINGS: 'settings',
  EDITOR: 'editor',
  NONE: null,
  TREE: 'tree',
  ASSIGNMENT: 'assignment',
  SEARCH: 'search',
};

export const PLUGINS_PATH = 'plugins';

export const USERINFO_INTERVAL = 10 * 60 * 1000; // 10 minute.
export const CONFLICT_ERROR_MESSAGE = 'Document update conflict';
export const API_ERROR_MESSAGE = 'Something went wrong';

export const HOME_PAGE_LINK = '/';

export const URL_LIST: UrlList = {
  auth: `${env.API_URL}/users/authorize`,
  logout: `${env.API_URL}/users/logout`,
  users: `${env.API_URL}/rest/dropdown/usersinorganization`,
  settings: `${env.API_URL}/settings`,
  spaces: `${env.API_URL}/spaces`,
  docs: `/docs`,
};
